// @ts-check

import angular from 'angular';

/**
 * Get Module
 */
angular
  .module('RcmDialog')

  /**
   * RcmDialog.rcmBlankDialog
   */
  .directive('rcmBlankDialog', [
    '$compile',
    '$templateCache',
    function ($compile, $templateCache) {
      return {
        restrict: 'A',
        compile(tElement, tAttrs, transclude) {
          return function (/** @type {any} */ scope, elm, attrs, ctrl) {
            const dialogId = attrs.rcmBlankDialog;

            scope.dialog = RcmDialog.getDialog(dialogId);

            // Bring in contentscope scope vars
            scope.contentscope = scope.dialog.contentscope;

            $templateCache.remove(scope.dialog.url);

            scope.loading = scope.dialog.loading = false;

            scope.$apply();
          };
        },
        scope: {},
        template: '<div ng-include="dialog.url"><!--{{dialog.url}}--></div>',
      };
    },
  ]);
